/**
 * 通用异常处理：
 * 1. 浏览器拦截：比如跨域拦截、网络超时
 * 2. 业务通用异常：：非2xx状态码
 */
import axios from '@didi/dajax';
import wsgEnv from '@/lib/wsgsdk/wsgenv';
import { dontNeedLoginRouteMap } from '@/utils/router.js';
import { ERROR_CODE } from '@/const/base.js';
import passportMonitor from '@/utils/passportMonitor';
import { apiMonitorLog } from '@/omega/common/logs';

// 请求响应拦截器
axios.interceptors.response.use(
  (response) => {
    apiMonitorLog(response)
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加安全sdk请求拦截器
axios.interceptors.request.use(
  async (config) => {
    return wsgEnv.wsgEnvToServer(config);
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    const status = response.status;
    let errmsg = '';
    if (status < 200 || status >= 300) {
      // 处理http错误，抛到业务代码 ========todo data格式
      if (typeof response.data === 'string') {
        response.data = {};
      } else {
        response.data.errmsg = errmsg;
      }

      if (errmsg) {
        console.log(errmsg);
      }
    }
    return response.data;
  },
  (error) => {
    const response = error.response;
    if (response === undefined) {
      console.log('=========== 浏览器拦截 ===========');
      // 浏览器拦截，比如跨域拦截、网络超时
    } else {
      console.log('=========== 业务异常  ===========');
      // 状态码非2xx触发
    }
    return Promise.reject(error);
  }
);

// 登录拦截器
axios.interceptors.response.use(
  (response) => {
    // 状态码为50002（未登录）并且该页面需要登录状态时，跳转到 passport 登录
    if (
      response.errno === ERROR_CODE.NOT_LOGIN &&
      !dontNeedLoginRouteMap[location.pathname]
    ) {
      passportMonitor.login();
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
